module.exports = __webpack_public_path__ + "static/img/14000531.e4a07a98.png";